// extracted by mini-css-extract-plugin
export default {"dimensionsRowClass":"src-pages-ProductEditor-Components-Dimensions-css__dimensionsRowClass--pfJXU"};